export const generateArrayOfN = (n: number) => Array.from(Array(n).keys())
export const generateArrayOfNBits = (n: number) => generateArrayOfN(n).map(i=> 1<<i)